import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const EditStatus = Loadable(
  lazy(() =>
    import("./EditStatus").then(({ EditStatus }) => ({
      default: EditStatus,
    }))
  )
);

const StatusList = Loadable(
  lazy(() =>
    import("./statusList").then(({ StatusList }) => ({
      default: StatusList,
    }))
  )
);

export const StatusRoutes = [
  {
    path: "/org-status",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.STATUS_LIFE_CYCLE]}>
        <EditStatus isEnr={false} />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/enr-status",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_STATUS]}>
        <StatusList isEnr={true} />
      </AuthorizedRoute>
    ),
  },
];
